
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.366 7.682a10.556 10.556 0 003.952 3.952l.884-1.238a1 1 0 011.294-.296 11.422 11.422 0 004.583 1.364 1 1 0 01.921.997v4.462a1 1 0 01-.898.995A15.51 15.51 0 0115.5 18C6.94 18 0 11.06 0 2.5 0 1.962.027 1.428.082.898A1 1 0 011.077 0h4.462a1 1 0 01.997.921A11.422 11.422 0 007.9 5.504a1 1 0 01-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357A13.41 13.41 0 014.647 2H2.01c-.006.166-.009.333-.009.5C2 9.956 8.044 16 15.5 16c.167 0 .334-.003.5-.01v-2.637a13.413 13.413 0 01-3.668-1.097l-1.357 1.9a12.446 12.446 0 01-1.588-.75l-.058-.033a12.556 12.556 0 01-4.702-4.702l-.033-.058a12.442 12.442 0 01-.75-1.588z","fill":"#FAAD14"}})])
          )
        }
      }
    